module.exports = __webpack_public_path__ + "static/media/jewelry-dept-reinvention.78b32163.png";